export default function Hero() {
    return (
      <div className="relative h-screen min-h-[70vh] flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763645185/fe42525855e23e75915b6e49227040490d775b37_dxba1v.png"
            alt="Offshore drilling rig at sunset"
            className="w-full h-full object-cover object-center"
          />
        </div>
  
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/40 z-10" />
  
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full pt-[150px]">
          <div className="max-w-[910px]">
            {/* Main Heading */}
            <h1 className="text-4xl md:text-[40px] lg:text-[56px] xl:text-[50px] text-white font-bold mb-6 leading-tight">
              Providing integrated rig systems, solids control tech, and field support to speed up drilling and production.
            </h1>
  
            {/* Subheading */}
            <p className="text-[17px] max-w-[700px] text-gray-200 mb-8 leading-relaxed">
              Integrated rigs, solids control systems, and field execution built for speed, safety, and operational certainty from planning to production.
            </p>
  
            {/* CTA Button */}
            <button className="group bg-[#00458F] hover:bg-blue-700 text-white font-semibold px-5 py-[18px]  transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl hover:scale-105">
              Explore our solutions
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </div>
        </div>
  
       
      </div>
    );
  }